import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useLocation, useNavigate } from "react-router-dom";
import NISEdit from './nisEdit';
import NisMachineriesAdd from './NisMachineriesAdd';
import useOfficers from '../Hooks/NisOfficersHooks/useOfficers';
import useDeleteNISfsResult from '../Hooks/NisFsResultHooks/useDeleteNisfsResult';
import adminBg from '../Assets/bg/adminbg.jpg';
import Loader from '../Components/Loader';
import DeleteConfirmationModal from '../Components/DeleteConfirmationModal';
import ExcelJS from 'exceljs';

const SAMPLE_OFFICERS_ROWS = [
  {
    id: 'sample-officer-1',
    ia_name: 'Sample IA - Pilar Farmers Association',
    lastname: 'Dela Cruz',
    firstname: 'Maria',
    mothers_maidenName: 'Santos',
    sex: 'Female',
    civil_status: 'Married',
    name_of_spouse: 'Juan Dela Cruz',
    date_of_birth: '1988-03-12',
    tin: '123-456-789-000',
    positions: 'President',
    educational_attainment: 'College Graduate',
    createdAt: '2025-01-01T00:00:00.000Z',
    isSample: true
  },
  {
    id: 'sample-officer-2',
    ia_name: 'Sample IA - Alicia Water Users Group',
    lastname: 'Reyes',
    firstname: 'Carlos',
    mothers_maidenName: 'Villanueva',
    sex: 'Male',
    civil_status: 'Single',
    name_of_spouse: '-',
    date_of_birth: '1991-07-25',
    tin: '987-654-321-000',
    positions: 'Treasurer',
    educational_attainment: 'College Level',
    createdAt: '2025-01-02T00:00:00.000Z',
    isSample: true
  }
];

const NisOfficers = ({ darkMode, year, onBack, onSelect }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();
  const [showEditPanel, setShowEditPanel] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedYear, setSelectedYear] = useState(null);
  console.log("NISMachineries received year:", year);
  const { data, loading, error, refetch } = useOfficers(year);

  const [isSidebarExpanded] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [showRightPanel, setShowRightPanel] = useState(false);
  const [showImportPanel, setShowImportPanel] = useState(false);
  const fileInputRef = useRef(null);
  const [showAllData, setShowAllData] = useState(false);
  const { deleteNISfsResult, loading: deleteLoading, error: deleteError, successMessage } = useDeleteNISfsResult();
  const [confirmDelete, setConfirmDelete] = useState(null);
  const [headerTitle, setHeaderTitle] = useState(localStorage.getItem('nisOfficers_headerTitle') || 'NIS - IA OFFICERS ');
  const [headerDate, setHeaderDate] = useState(localStorage.getItem('nisOfficers_headerDate') || `REGION 7, ${selectedYear || '2025'}`);
  const [headerProvince, setHeaderProvince] = useState(localStorage.getItem('nisOfficers_headerProvince') || 'CY 2025');
  const [isEditingHeader, setIsEditingHeader] = useState(false);
  const [addSuccessMessage, setAddSuccessMessage] = useState(null)

  const saveHeader = () => {
    localStorage.setItem('nisOfficers_headerTitle', headerTitle);
    localStorage.setItem('nisOfficers_headerDate', headerDate);
    localStorage.setItem('nisOfficers_headerProvince', headerProvince);
    setIsEditingHeader(false);
  };

  const handleAddSuccess = (msg) => {
    setAddSuccessMessage(msg || 'NIS Officers data successfully added!');
    setTimeout(() => setAddSuccessMessage(null), 3000);
    // Force refetch after adding data
    if (refetch) refetch();
  };

console.log("Received year from location.state:", location.state?.year);


  useEffect(() => {
  // Use year from location.state if available
  if (location.state?.year) {
    setSelectedYear(location.state.year);
    setHeaderDate(`IA Officers, ${location.state.year}`);
    return;
  }

}, [location.state?.year]);


  useEffect(() => {
    if (selectedYear && refetch) {
      console.log('Refetching data for year:', selectedYear);
      refetch();
    }
  }, [selectedYear, refetch]);

   useEffect(() => {
    console.log('Raw data from useNisFsResult hook:', data);
  }, [data]);
  
  useEffect(() => {
    const scrollContent = document.getElementById('scrollContent');
    const bottomScroll = document.getElementById('bottomScroll');

    if (scrollContent && bottomScroll) {
      const onBottomScroll = () => {
        scrollContent.scrollLeft = bottomScroll.scrollLeft;
      };

      const onContentScroll = () => {
        bottomScroll.scrollLeft = scrollContent.scrollLeft;
      };

      bottomScroll.addEventListener('scroll', onBottomScroll);
      scrollContent.addEventListener('scroll', onContentScroll);

      return () => {
        bottomScroll.removeEventListener('scroll', onBottomScroll);
        scrollContent.removeEventListener('scroll', onContentScroll);
      };
    }
  }, []);

  const handleClose = () => {
    setShowRightPanel(false);
    console.log('Form closed');
  };

  const handleRowClick = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const handleEditData = (item) => {
    console.log('Editing IA ID:', item.id);
    setSelectedItem(item);
    setShowEditPanel(true);
  };

  const closeEditPanel = () => {
    setShowEditPanel(false);
    setSelectedItem(null);
  };

  const handleDeleteClick = (item) => {
    setConfirmDelete(item);
  };

  const handleBackClick = () => {
    const pendingCisReturn = localStorage.getItem('cisMachineriesReturn');
    if (pendingCisReturn && typeof onSelect === 'function') {
      onSelect('CIS');
      return;
    }

    if (typeof onBack === 'function') {
      onBack();
      return;
    }

    navigate(-1);
  };

  const flattenedData = Array.isArray(data)
    ? (data.length > 0 && data.some(item => item?.ias)
      ? data.flatMap(isItem =>
          (isItem.ias || []).flatMap(positionItem =>
            (positionItem.rows || []).map(row => ({
              ...row,
              id: row.id,
              positions: row.positions || positionItem.positions,
              ia_name: row.ia_name || isItem.ia_name,
              createdAt: row.createdAt || isItem.createdAt || positionItem.createdAt
            }))
          )
        )
      : data.map(row => ({
          ...row,
          id: row.id,
          positions: row.positions,
          ia_name: row.ia_name,
          createdAt: row.createdAt
        })))
      .sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0))
    : [];

  const hasBackendData = flattenedData.length > 0;
  const dataSource = hasBackendData ? flattenedData : SAMPLE_OFFICERS_ROWS;

  console.log('Flattened Data:', flattenedData);

  const normalizedQuery = searchQuery.trim().toLowerCase();
  const filteredData = normalizedQuery
    ? dataSource.filter(item =>
        Object.values(item).some(val =>
          (val?.toString()?.toLowerCase() || '').includes(normalizedQuery)
        )
      )
    : dataSource;

  const isOrder = [...new Set(dataSource.map(item => item.ia_name))];

  const uniqueISGroups = Object.entries(
    filteredData.reduce((acc, item) => {
      const group = item.ia_name || 'Unknown';
      if (!acc[group]) acc[group] = { items: [] };
      acc[group].items.push(item);
      return acc;
    }, {})
  ).sort(([a], [b]) => isOrder.indexOf(a) - isOrder.indexOf(b));

  const displayedGroups = showAllData
    ? uniqueISGroups
    : uniqueISGroups.slice(0, 1).map(([positions, group]) => [positions, { ...group, items: group.items.slice(0, 8) }]);

  const fallbackGroups = [
    [
      'Sample IA - Pilar Farmers Association',
      { items: SAMPLE_OFFICERS_ROWS }
    ]
  ];
  const groupsToRender = displayedGroups.length > 0 ? displayedGroups : fallbackGroups;

  const shouldShowButton = uniqueISGroups.length > 1 || uniqueISGroups.some(([, group]) => group.items.length > 8);

  const handleManageData = (value) => {
    if (value === 'import') {
      fileInputRef.current.click(); // Trigger file input click
    } else if (value === 'export') {
      handleExport();
    }
  };

  const handleImportFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file); // Store the selected file
      setShowImportPanel(true); // Show import panel after file selection
      event.target.value = null; // Reset file input
    }
  };

 const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('NisFsResult');

    worksheet.mergeCells('A1:Q1');
    const titleCell = worksheet.getCell('A1');
    titleCell.value = headerTitle;
    titleCell.font = { name: 'Calibri', size: 18, bold: true };
    titleCell.alignment = { horizontal: 'left', vertical: 'middle' };

    worksheet.mergeCells('A2:Q2');
    worksheet.getCell('A2').value = headerDate;
    worksheet.getCell('A2').font = { name: 'Calibri', size: 18 };

    worksheet.mergeCells('A3:Q3');
    worksheet.getCell('A3').value = headerProvince;
    worksheet.getCell('A3').font = { name: 'Calibri', size: 18 };

    worksheet.addRow([]);

    const mainHeaders = [
      'NO', 'LAST NAME ', 'FIRST NAME', 'MOTHERS MAIDEN NAME', 'SEX',
      'CIVIL STATUS ', 'NAME OF SPOUSE ', 'DATE OF BIRTH', 'TIN','POSITIONS', 'EDUCATIONAL ATTAINMENT'
    ];
    const mainHeaderRow = worksheet.addRow(mainHeaders);

    mainHeaderRow.eachCell((cell, colNumber) => {
      cell.font = { size: 12, bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '2E7D32' } };
      cell.alignment = { horizontal: 'center', wrapText: true };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      };
      if (colNumber === 5) {
        worksheet.mergeCells(`J${mainHeaderRow.number}:K${mainHeaderRow.number}`);
        cell.alignment = { horizontal: 'center', wrapText: true };
      }
      if (colNumber === 13) {
        worksheet.mergeCells(`M${mainHeaderRow.number}:N${mainHeaderRow.number}`);
        cell.alignment = { horizontal: 'center', wrapText: true };
      }
    });

    const subHeaders = [
      '', '', '',  'Barangay', 'Municipality',  'Province',  '',  
      '', '',  'Functional', 'Not Functionality',  '',  '',  'YES (Registration No.)', 'NO'
    
    ];
    const subHeaderRow = worksheet.addRow(subHeaders);

    subHeaderRow.eachCell((cell, colNumber) => {
      cell.font = { size: 12, bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: '4CAF50' } };
      cell.alignment = { horizontal: 'center', wrapText: true };
      cell.border = {
        top: { style: 'thin', color: { argb: '000000' } },
        bottom: { style: 'thin', color: { argb: '000000' } },
        left: { style: 'thin', color: { argb: '000000' } },
        right: { style: 'thin', color: { argb: '000000' } },
      };
      if (colNumber === 15) {
        worksheet.mergeCells(`O${subHeaderRow.number}:Q${subHeaderRow.number}`);
      }
    });

    let rowIndex = 1;
    displayedGroups.forEach(([positions, group]) => {
      const groupRow = worksheet.addRow([positions.toUpperCase()]);
      worksheet.mergeCells(`A${groupRow.number}:Q${groupRow.number}`);
      groupRow.eachCell(cell => {
        cell.font = { size: 12, bold: true };
        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'CADABA' } };
        cell.alignment = { horizontal: 'left', vertical: 'middle' };
        cell.border = {
          top: { style: 'thin', color: { argb: '000000' } },
          bottom: { style: 'thin', color: { argb: '000000' } },
          left: { style: 'thin', color: { argb: '000000' } },
          right: { style: 'thin', color: { argb: '000000' } },
        };
      });

      group.items.forEach((item) => {
        const row = worksheet.addRow([
          rowIndex++,
          item.lastname,
          item.firstname,
          item.mothers_maidenName,
          item.sex,
          item.civil_status,
          item.name_of_spouse,
          item.date_of_birth,
          item.tin,
          item.positions,
          item.educational_attainment
          
        ]);

        row.eachCell((cell, colNumber) => {
          cell.font = { size: 12 };
          cell.border = {
            top: { style: 'thin', color: { argb: '000000' } },
            bottom: { style: 'thin', color: { argb: '000000' } },
            left: { style: 'thin', color: { argb: '000000' } },
            right: { style: 'thin', color: { argb: '000000' } },
          };
          if ([3, 4, 6, 7].includes(colNumber)) {
            cell.alignment = { horizontal: 'left', vertical: 'top', wrapText: true };
          } else if ([14, 15, 16, 17].includes(colNumber)) {
            cell.alignment = { horizontal: 'right', vertical: 'top', wrapText: true };
          } else {
            cell.alignment = { horizontal: 'center', vertical: 'top', wrapText: true };
          }
        });
      });
    });

    worksheet.columns = [
      { key: 'no', width: 5 },
      { key: 'lastname', width: 30 },
      { key: 'firstname', width: 25 },
      { key: 'mothers_maidenName', width: 15 },
      { key: 'sex', width: 25 },
      { key: 'civil_status', width: 25 },
      { key: 'name_of_spouse', width: 25 },
      { key: 'date_of_birth', width: 15 },
      { key: 'tin', width: 15 },
      { key: 'positions', width: 10 },
      { key: 'educational_attainment', width: 15 },
    ];

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    });

    if (window.isSecureContext && 'showSaveFilePicker' in window) {
      try {
        const options = {
          suggestedName: `NIS_Officers_BIIS_${selectedYear || '2025'}.xlsx`,
          types: [{
            description: 'Excel File',
            accept: {
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
            }
          }]
        };
        const handle = await window.showSaveFilePicker(options);
        const writable = await handle.createWritable();
        await writable.write(blob);
        await writable.close();
      } catch (err) {
        console.error('Error saving file:', err.name, err.message || err);
        if (err.name !== 'AbortError') {
          alert('Save failed due to an unexpected error. Check the console.');
        }
      }
    } else {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `FS_Officers_BIIS_${selectedYear || '2025'}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }
  };

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        backgroundColor: darkMode ? 'black' : 'white',
      }}>
        <Loader />
      </div>
    );
  }

  if (error) {
    return <div>Error: { error}</div>;
  }


  return (
    <>
      {addSuccessMessage && (
        <div
          style={{
            position: 'fixed',
            top: '20px',
            right: '20px',
            backgroundColor: '#4caf50',
            color: '#fff',
            padding: '10px 20px',
            borderRadius: '5px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            zIndex: 9999
          }}
        >
          {addSuccessMessage}
        </div>
      )}
      <BackButton type="button" onClick={handleBackClick}>Back</BackButton>
      <SlidingPanel darkMode={darkMode} show={true} isExpanded={isSidebarExpanded}>
        <div style={{ display: 'flex', height: '100vh' }}>
          <Container darkMode={darkMode} tableisSidebarExpanded={isSidebarExpanded} showRightPanel={showRightPanel || showEditPanel}>
            <HeaderContainer>
              <HeaderLeft>
                <HeaderText>
                  {isEditingHeader ? (
                    <>
                      <input value={headerTitle} onChange={(e) => setHeaderTitle(e.target.value)} />
                      <input value={headerDate} onChange={(e) => setHeaderDate(e.target.value)} />
                      <input value={headerProvince} onChange={(e) => setHeaderProvince(e.target.value)} />
                      <button onClick={saveHeader}>Save</button>
                      <button onClick={() => setIsEditingHeader(false)}>Cancel</button>
                    </>
                  ) : (
                    <>
                      <h2>{headerTitle}</h2>
                      <p>{headerDate}</p>
                      <p>{headerProvince}</p>
                      <button onClick={() => setIsEditingHeader(true)}>Edit</button>
                    </>
                  )}
                </HeaderText>
              </HeaderLeft>
              {!hasBackendData && (
                <div style={{ color: '#2e7d32', fontWeight: 600, marginRight: '12px' }}>
                  Showing sample data
                </div>
              )}
              <RightControls>
                <SearchInput
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <StyledButton onClick={() => setShowRightPanel(true)}>
                  Add Officers
                </StyledButton>
               <ManageDataSelect onChange={(e) => handleManageData(e.target.value)}>
          <option value="">Manage Data</option>
          <option value="import">Import</option>
          <option value="export">Export</option>
        </ManageDataSelect>
        <input
          type="file"
          accept=".xlsx"
          onChange={handleImportFileSelect}
          style={{ display: 'none' }}
          ref={fileInputRef}
        />
              </RightControls>
            </HeaderContainer>
            <TableContainer>
              <TableWrapper isExpanded={isSidebarExpanded} id="tableWrapper">
                <div id="scrollContent" style={{ width: '100%', overflowX: 'auto' }}>
                  <Table darkMode={darkMode}>
                    <thead>
                      <tr>
                        <TableHeader darkMode={darkMode}>ACTIONS</TableHeader>
                        <TableHeader darkMode={darkMode}>NO</TableHeader>
                        <TableHeader darkMode={darkMode}>LAST NAME </TableHeader>
                        <TableHeader darkMode={darkMode}>FIRST NAME </TableHeader>         
                        <TableHeader darkMode={darkMode}>MOTHERS MAIDEN NAME </TableHeader>
                         <TableHeader darkMode={darkMode}>SEX </TableHeader>
                        <TableHeader darkMode={darkMode}>CIVIL STATUS </TableHeader>
                        <TableHeader darkMode={darkMode}>NAME OF SPOUSE </TableHeader>
                        <TableHeader darkMode={darkMode}>DATE OF BIRTH</TableHeader>
                        <TableHeader darkMode={darkMode}>TIN</TableHeader>
                        <TableHeader darkMode={darkMode}>POSITIONS</TableHeader>
                        <TableHeader darkMode={darkMode}>EDUCATIONAL ATTAINMENT</TableHeader>
                       
                      </tr>
                      <tr>
                        <TableHeaderS darkMode={darkMode}></TableHeaderS>
                        <TableHeaderS colSpan="11" darkMode={darkMode}></TableHeaderS> 
                        

                      </tr>
                    </thead>
                    <tbody>
                      {groupsToRender.map(([ia_name, group]) => {
                        let previousIA = null;
                        return (
                          <React.Fragment key={ia_name}>
                            <tr>
                              <td
                                colSpan="100%"
                                style={{
                                  backgroundColor: '#cadaba',
                                  fontWeight: 'bold',
                                  textAlign: 'left',
                                  paddingLeft: '10px'
                                }}
                              >
                                {ia_name.toUpperCase()}
                              </td>
                            </tr>
                            {group.items.reduce((acc, item, index) => {
                              const showIA = item.positions !== previousIA;
                              previousIA = item.positions;
                              acc.push(
                                <TableRow
                                  key={`${item.id}-${index}`}
                                  darkMode={darkMode}
                                  onClick={() => {
                                    if (!item.isSample) {
                                      handleRowClick(item);
                                    }
                                  }}
                                >
                                  <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px', padding: '8px 0' }}>
                                    {!item.isSample ? (
                                      <ButtonGroup>
                                        <StyledButton onClick={(e) => {
                                          e.stopPropagation();
                                          handleEditData(item);
                                        }}>
                                          ✎
                                        </StyledButton>
                                        <StyledButton onClick={(e) => { e.stopPropagation(); handleDeleteClick(item); }}>❌</StyledButton>
                                      </ButtonGroup>
                                    ) : (
                                      <span style={{ color: '#777' }}>-</span>
                                    )}
                                  </TableData>
                                  <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '40px' }}>
                                    {index + 1}
                                  </TableData>
                                  <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '240px' }}>
                                    {showIA ? item.lastname : ''}
                                  </TableData>
                                  <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '200px' }}>
                                    {item.firstname}
                                  </TableData>
                                  <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '80px' }}>
                                    {item.mothers_maidenName}
                                  </TableData>
                                  <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '200px' }} className="station-mail">
                                    {item.sex}
                                  </TableData>
                                  <TableData darkMode={darkMode} style={{ textAlign: 'left', minWidth: '200px' }} className="station-iaPres">
                                    {item.civil_status}
                                  </TableData>
                                  <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '200px' }}>
                                    {item.name_of_spouse}
                                  </TableData>
                                  <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }}>
                                    {item.date_of_birth}
                                  </TableData>
                                  <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }} className="station-secNum">
                                    {item.tin}
                                  </TableData>
                                  <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '80px' }} className="station-secDate">
                                    {item.positions}
                                  </TableData>
                                  <TableData darkMode={darkMode} style={{ textAlign: 'center', minWidth: '120px' }} className="station-iaTin">
                                    {item.educational_attainment}
                                  </TableData> 
                                </TableRow>
                              );
 
                              return acc;
                            }, [])}
               
                          </React.Fragment>
                        );
                      })}
    
                    </tbody>
                  </Table>
                  {!showAllData && shouldShowButton && (
                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                      <ShowAllButton onClick={() => setShowAllData(true)}>
                        Show All Data
                      </ShowAllButton>
                    </div>
                  )}
                  {showAllData && shouldShowButton && (
                    <div style={{ textAlign: 'center', marginTop: '10px' }}>
                      <ShowAllButton onClick={() => setShowAllData(false)}>
                        Show Less Data
                      </ShowAllButton>
                    </div>
                  )}
                </div>
              </TableWrapper>
              <div
                style={{
                  overflowX: 'auto',
                  scrollbarWidth: 'none',
                  msOverflowStyle: 'none',
                }}
                className="hide-scrollbar"
                id="bottomScroll"
              >
                <div style={{ width: '2000px', height: '1px' }} />
              </div>
              {confirmDelete && (
                <DeleteConfirmationModal
                  itemName={confirmDelete.lastname}
                  onCancel={() => setConfirmDelete(null)}
                  onConfirm={async () => {
                    await deleteNISfsResult(confirmDelete.id);
                    refetch();
                    setConfirmDelete(null);
                  }}
                />
              )}
              {showEditPanel && selectedItem && selectedItem.id && (
                <NISEdit
                  selectedItem={selectedItem}
                  onClose={closeEditPanel}
                  darkMode={darkMode}
                />
              )}
            </TableContainer>
          </Container>
          <RightPanel darkMode={darkMode} show={showRightPanel}>
            <NisMachineriesAdd
              darkMode={darkMode} 
              onClose={handleClose} 
              onAddSuccess={handleAddSuccess} />   
          </RightPanel>
        </div>
      </SlidingPanel>
    </>
  );
};

export default NisOfficers;

// Styled Components
const Container = styled.div`
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#f2f2f2')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  color: ${({ darkMode }) => (darkMode ? '#bdb9b9ff' : '#333')};
  padding: 80px 20px 20px;
  width: ${({ isSidebarExpanded, showRightPanel }) => (showRightPanel ? '57%' : isSidebarExpanded ? 'calc(100% - 100px)' : '98%')};
  min-height: 100vh;
  overflow-y: auto;
  margin-left: ${({ isSidebarExpanded }) => (isSidebarExpanded ? '110px' : '10px')};
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transition: margin-left 0.3s ease, width 0.3s ease;
  box-sizing: border-box;
`;

const SlidingPanel = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  width: 99%;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#f2f2f2')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  transform: translateX(100%);
  transition: transform 0.5s ease, right 0.3s ease-in-out, width 0.3s ease-in-out;
  z-index: 2;
  padding: 20px;
  box-sizing: border-box;

  ${({ show }) => show && `transform: translateX(0);`}
`;

const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0 40px;
`;

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const HeaderText = styled.div`
  margin-bottom: 10px;
  margin-top: -38px;

  h2 {
    margin: 0;
    font-size: 22px;
    color: ${({ darkMode }) => (darkMode ? '#ffffff' : '#333')};
  }

  p {
    margin: 0;
    font-size: 18px;
    color: ${({ darkMode }) => (darkMode ? '#cccccc' : '#555')};
  }
`;

const YearGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RightControls = styled.div`
  display: flex;
  gap: 10px;
  align-items: flex-end;
  padding-right: 40px;
`;

const StyledButton = styled.button`
  margin: 0 2px;
  padding: 6px 10px;
  background-color: #eee;
  border: 1px solid #aaa;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
  font-size: 14px;

  &:hover {
    background-color: #ddd;
  }
`;

const ManageDataSelect = styled.select`
  padding: 6px 10px;
  background-color: #eee;
  border: 1px solid #aaa;
  border-radius: 4px;
  color: #333;
  cursor: pointer;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: #388e3c;
  }

  &:hover {
    background-color: #ddd;
  }

  option {
    color: #333;
    background-color: #fff;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

const ShowAllButton = styled.button`
  margin: 20px auto;
  display: block;
  padding: 8px 16px;
  background-color: #eee;
  border: 1px solid #aaa;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #ddd;
  }
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #4caf50;
  border-radius: 4px;
  background-color: #ffffff;
  color: #333;
  font-size: 14px;
  width: 100%;
  transition: border-color 0.2s ease, background-color 0.2s ease;

  &:focus {
    outline: none;
    border-color: #388e3c;
  }

  &:hover {
    background-color: #f1f1f1;
  }

  &::placeholder {
    color: #888;
    font-style: italic;
    font-size: 14px;
  }
`;

const TableWrapper = styled.div`
  width: 100%;
  height: 75vh;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 10px;
  position: relative;
  background-color: ${({ darkMode }) => (darkMode ? 'rgb(42, 48, 42)' : '#f2f2f2')};

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  #scrollContent {
    width: 100%;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  #scrollContent::-webkit-scrollbar {
    display: none;
  }
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 2120px;
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
`;

const TableHeader = styled.th`
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#2e7d32')};
  color: ${({ darkMode }) => (darkMode ? '#333' : '#fff')};
  padding: 10px;
  font-size: 14px;
  border: 1px solid #ddd;
  text-align: center;
  vertical-align: middle;

  &:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
    background-color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#2e7d32')};
  }

  &[colspan="2"] {
    text-align: center;
    font-weight: bold;
  }
`;

const TableHeaderS = styled.th`
  position: sticky;
  top: 39px;
  z-index: 1;
  background-color: ${({ darkMode }) => (darkMode ? '#1b5e20' : '#4caf50')};
  color: #ffffff;
  padding: 0 10px;
  border: 1px solid #ddd;
  font-size: 12px;
  text-align: center;

  &:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
    background-color: ${({ darkMode }) => (darkMode ? '#1b5e20' : '#4caf50')};
  }
`;

const TableData = styled.td`
  padding: 5px;
  font-size: 12px;
  border: 1px solid #ddd;
  color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
  transition: background-color 0.3s ease, color 0.3s ease;

  &:first-child {
    position: sticky;
    left: 0;
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)' : '#f2f2f2')};
    z-index: 1;
  }

  &.station-mail {
    min-width: 200px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-secNum {
    min-width: 120px;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-secDate {
    min-width: 80px;
    max-width: 80px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-iaTin {
    min-width: 120px;
    max-width: 120px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &.station-iaPres {
    min-width: 200px;
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const TableRow = styled.tr`
  background: ${({ darkMode }) => (darkMode ? 'rgba(3, 82, 33, 0.3)' : '#fff')};
  backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};
  -webkit-backdrop-filter: ${({ darkMode }) => (darkMode ? 'blur(10px)' : 'none')};

  &:hover {
    background-color: ${({ darkMode }) => (darkMode ? 'rgb(37, 112, 46)' : '#f1f1f1')};
    color: ${({ darkMode }) => (darkMode ? '#f2f2f2' : '#333')};
  }

  &:hover td {
    background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
    color: ${({ darkMode }) => (darkMode ? '#fff' : '#333')};
  }

  &:nth-child(even) {
    background-color: ${({ darkMode }) => (darkMode ? 'rgba(3, 82, 33, 0.3)' : '#f9f9f9')};
  }
`;

const RightPanel = styled.div`
  position: fixed;
  top: 0;
  right: ${({ show }) => (show ? '0' : '-45%')};
  width: 43%;
  height: 100%;
  background-color: ${({ darkMode }) => (darkMode ? 'transparent' : '#fff')};
  background-image: ${({ darkMode }) => (darkMode ? `url(${adminBg})` : 'none')};
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  box-shadow: -4px 0 10px rgba(0, 0, 0, 0.2);
  z-index: 5;
  padding: 5px;
  box-sizing: border-box;
  transition: right 0.3s ease-in-out;
`;

const TableContainer = styled.div`
  margin-top: 0;
  padding: 0 20px;
`;

const BackButton = styled.button`
  position: fixed;
  left: 74px;
  bottom: 18px;
  z-index: 40;
  padding: 8px 14px;
  border: 1px solid #2e7d32;
  border-radius: 4px;
  background-color: #ffffff;
  color: #2e7d32;
  font-size: 14px;
  cursor: pointer;

  &:hover {
    background-color: #f2fff2;
  }
`;